import React, { useState } from 'react';
import { Wrapper, Titles, Contents, Title } from './styled';

const Tabs = ({ sections }) => {
  const [selected, setSelected] = useState('Parameters');

  const getSectionContent = (section) => {
    const { element = null, title = '' } = section;
    if (selected !== title) return null;
    return element;
  };

  const getSectionTitle = (section) => {
    const { title = '' } = section;
    return (
      <Title children={ title } selected={ selected === title } onClick={ () => setSelected(title) } />
    );
  };

  return (
    <Wrapper>
      <Titles>
        {sections.map(getSectionTitle)}
      </Titles>
      <Contents>
        {sections.map(getSectionContent)}
      </Contents>
    </Wrapper>
  );
};

export default Tabs;
